export const scrollToError = (error) => {
  if (error.includes("user")) {
    const checkoutOnePageContainerElement = document.querySelector(
      ".purchase-form-container",
    );

    checkoutOnePageContainerElement?.scrollIntoView({
      block: "start",
      behavior: "smooth",
    });
  }

  if (error.includes("address")) {
    const addressFormContainerElement = document.querySelector(
      ".address-form-container",
    );

    addressFormContainerElement?.scrollIntoView({
      block: "start",
      behavior: "smooth",
    });
  }

  if (error.includes("credit_card")) {
    const creditCardFormContainerElement = document.querySelector(
      ".credit-card-form-container",
    );

    creditCardFormContainerElement?.scrollIntoView({
      block: "start",
      behavior: "smooth",
    });
  }

  if (error.includes("billing_information")) {
    const billingInformationFormContainerElement = document.querySelector(
      ".billing-information-form-container",
    );

    billingInformationFormContainerElement?.scrollIntoView({
      block: "start",
      behavior: "smooth",
    });
  }
};
